// One line per wash that says what it does THAT THE OTHERS DO NOT, keyed by
// booking slug. The only copy of these lines: the home page's wash cards
// (pages/home/sections/whats-included) and the booking screen's wash picker
// (pages/booking/components/wash-picker) both read them from here, so the
// two cannot drift apart.
//
// Robin, 5 Oct, on the picker: "the details in each box need to focus on
// whats included thats not in the other services .. otherwise they all read
// the same". So each line leads with the difference, and every noun in it is
// a ticked row in pages/services/compare/washes.js FEATURE_GROUPS:
//   Mini Valet PLUS = the Mini Valet's four rows plus basic body wax,
//     interior windows, the screenwash/oil/fluid check and the gutters.
//   Full Valet = every PLUS row except the basic body wax, which it replaces
//     with the HD Carnauba coating, plus the engine bay, the upholstery and
//     carpets shampooed and the spare wheel area. Hence "with the wax
//     upgraded", not a bare "everything in the PLUS".
//   Interior Only Valet scores nothing outside and no dash wipe, so it does
//     not claim "every surface".
//
// A wash with no line here keeps its database description.
export const WASH_DESCRIPTORS = {
  exterior_wash_and_wax: 'Outside only: hand washed and waxed for a deep, protected shine.',
  mini_valet: 'Fresh inside and out: hand washed, then vacuumed and wiped down inside.',
  mini_valet_plus: 'Everything in the Mini Valet, plus body wax, interior glass, a fluid check and the gutters.',
  interior_only_valet: 'Inside only, deep cleaned: seats and carpets shampooed, plus the glass and the spare wheel area.',
  full_valet:
    'Everything in the Mini Valet PLUS, with the wax upgraded to HD Carnauba, plus the engine bay and the seats and carpets shampooed.',
  dog_owners_valet: 'The vast majority of dog hair lifted out of the seats and carpets, shampooed inside and hand washed outside.'
}

// The one label the catalogue carries (DESIGN.md §3 records the exception):
// Mini Valet PLUS is by far the most booked wash.
export const WASH_LABELS = {
  mini_valet_plus: 'Most booked'
}
